import { action } from "satcheljs";
import type { AccountKey } from "owa-client-types";

export interface ON_FAVORITES_LOADEDActionMessage {
    accountKey: AccountKey;
}
const onFavoritesLoaded: (accountKey: AccountKey) => ON_FAVORITES_LOADEDActionMessage = action("ON_FAVORITES_LOADED", (accountKey: AccountKey): ON_FAVORITES_LOADEDActionMessage => {
    return {
        accountKey,
    };
});
export default onFavoritesLoaded;
